<template>
    <el-drawer
        title="编辑员工"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="机构名称">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="联系人">
                    <el-input v-model="form.contactName"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="域名">
                    <el-input v-model="form.domain" style="width: 100px"></el-input>
                    <span>.leadersir.cn</span>
                </el-form-item>
            </el-form>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">确 定</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                form: {...this.item},
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                let data = this.form;
                this.$ajaxPost("/institution/saveSubSchool", {
                    institution: data
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                return false;
            },

        },
        mounted() {
            this.show = true;
        },
        created() {

        }


    }
</script>
